import { PlantHalt } from '../../../../../types/plantHalts'

/**
 * Durata di un fermo in secondi.
 *
 * `PlantHalt` sovrascrive `duration` con la stringa formattata `H:MM:SS` e perde i secondi
 * grezzi (vedi il costruttore in `types/plantHalts.ts`), quindi il valore va ricalcolato da
 * `from`/`to`, che restano oggetti moment.
 */
export const haltSeconds = (halt: PlantHalt): number => {
  if (!halt.from || !halt.to) {
    return 0
  }
  const seconds = halt.to.diff(halt.from, 'seconds')
  return seconds > 0 ? seconds : 0
}

export const sumSeconds = (halts: PlantHalt[]): number => halts.reduce((acc, halt) => acc + haltSeconds(halt), 0)
